import Header from "./Headers";
import Const from '../util/Constants';
import Config from '../config/config';

class KanbanAPI {

  static list = (success, failure) => {
    fetch(
      Config.app.link + `api/kanban/`,
      new Header('GET')
    )
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static get = (id, success, failure) => {
    fetch(
      Config.app.link + `api/kanban/${id}`,
      new Header('GET')
    )
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static save = (kanban, success, failure) => {
    fetch(
      Config.app.link + 'api/kanban',
      new Header('POST', kanban)
    )
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static delete = (id, success, failure) => {
    fetch(
      Config.app.link + `api/kanban/delete/${id}`,
      new Header('POST')
    )
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
}

export default KanbanAPI;